import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  company() {
    return faker.company.name();
  },

  email() {
    return faker.internet.email(this.firstName, this.lastName);
  },

  firstName() {
    return faker.name.firstName();
  },

  lastName() {
    return faker.name.lastName();
  },

  siteId() {
    return faker.datatype.number({
      min: 1,
      max: 19,
    });
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
